// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"a0c6ec70","239":"aa044081","453":"c79495b0","455":"8caa3829","977":"b49cf61b"}[chunkId] + ".chunk.js";
};